'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataElementIntegerContainer = undefined;

var _arrayDifference = require('d2-utilizr/lib/arrayDifference');

var _arrayDifference2 = _interopRequireDefault(_arrayDifference);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _containerConfig = require('./containerConfig');

var _containerConfig2 = _interopRequireDefault(_containerConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataElementIntegerContainer = exports.DataElementIntegerContainer = undefined;

exports.DataElementIntegerContainer = DataElementIntegerContainer = function DataElementIntegerContainer(refs) {
    var appManager = refs.appManager;

    var i18n = refs.i18nManager.get();

    Ext.define('Ext.ux.container.DataElementIntegerContainer', {
        extend: 'Ext.container.Container',
        alias: 'widget.dataelementintegercontainer',
        cls: 'ns-dxselector',
        layout: 'column',
        bodyStyle: 'border:0 none',
        style: 'margin: ' + _containerConfig2.default.margin,
        getRecord: function getRecord() {
            var record = {},
                rangeSet = this.rangeSetCmp.getValue();

            var isRange = rangeSet !== _containerConfig2.default.defaultRangeSetId;

            record.dimension = this.dataElement.id;
            record.name = this.dataElement.name;

            if (isRange) {
                record.legendSet = {
                    id: rangeSet
                };

                var ranges = this.rangeValueCmp.getValue();

                if (ranges.length) {
                    record.filter = 'IN:' + ranges.join(';');
                }
            } else {
                if (this.valueCmp.getValue()) {
                    record.filter = this.operatorCmp.getValue() + ':' + this.valueCmp.getValue();
                }
            }

            return record;
        },
        setRecord: function setRecord(record) {
            if ((0, _isObject2.default)(record.legendSet) && record.legendSet.id) {
                //this.rangeSetCmp.pendingValue = record.legendSet.id;
                this.rangeSetCmp.store.add(appManager.getLegendSetById(record.legendSet.id));
                this.rangeSetCmp.setValue(record.legendSet.id);

                this.onRangeSetSelect(record.legendSet.id);

                if (record.filter) {
                    var a = record.filter.split(':');

                    if (a.length > 1 && (0, _isString2.default)(a[1])) {
                        this.onRangeSearchSelect(a[1].split(';'), true);
                    }
                }
            } else {
                this.rangeSetCmp.setValue(_containerConfig2.default.defaultRangeSetId);
                this.onRangeSetSelect(_containerConfig2.default.defaultRangeSetId);

                if (record.filter) {
                    var a = record.filter.split(':');

                    if (a.length > 1) {
                        this.operatorCmp.setValue(a[0]);
                        this.valueCmp.setValue(a[1]);
                    }
                }
            }
        },
        initComponent: function initComponent() {
            var container = this,
                idProperty = 'id',
                nameProperty = 'name',
                displayProperty = 'displayName';

            this.nameCmp = Ext.create('Ext.form.Label', {
                text: this.dataElement.name,
                flex: 1,
                style: 'padding:' + _containerConfig2.default.namePadding
            });

            this.addCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: 'padding: 0',
                height: 18,
                text: i18n.duplicate,
                handler: function handler() {
                    container.duplicateDataElement();
                }
            });

            this.removeCmp = Ext.create('Ext.button.Button', {
                cls: 'ns-linkbutton',
                style: _containerConfig2.default.removeCmpStyle,
                height: 18,
                text: i18n.remove,
                handler: function handler() {
                    container.removeDataElement();
                }
            });

            this.operatorCmp = Ext.create('Ext.form.field.ComboBox', {
                valueField: idProperty,
                displayField: nameProperty,
                queryMode: 'local',
                editable: false,
                width: _containerConfig2.default.operatorCmpWidth,
                style: 'margin-bottom:0',
                value: 'EQ',
                store: {
                    fields: [idProperty, nameProperty],
                    data: [{ id: 'EQ', name: '=' }, { id: 'GT', name: '>' }, { id: 'GE', name: '>=' }, { id: 'LT', name: '<' }, { id: 'LE', name: '<=' }, { id: 'NE', name: '!=' }]
                }
            });

            this.valueCmp = Ext.create('Ext.form.field.Number', {
                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
                style: 'margin-bottom:0'
            });

            this.rangeSearchStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty]
            });

            // function
            this.filterSearchStore = function (isLayout) {
                var selected = container.rangeValueCmp.getValue();

                // hack, using internal method to activate dropdown before filtering
                if (isLayout) {
                    container.rangeSearchCmp.onTriggerClick();
                    container.rangeSearchCmp.collapse();
                }

                // filter
                container.rangeSearchStore.clearFilter();

                container.rangeSearchStore.filterBy(function (record) {
                    return !(0, _arrayContains2.default)(selected, record.data[idProperty]);
                });
            };

            // function
            this.onRangeSearchSelect = function (ids, isLayout) {
                ids = (0, _arrayFrom2.default)(ids);

                // store
                for (var i = 0, id; i < ids.length; i++) {
                    id = ids[i];

                    if (container.rangeValueStore.findExact(idProperty, id) === -1) {
                        container.rangeValueStore.add(container.rangeSearchStore.getAt(container.rangeSearchStore.findExact(idProperty, id)).data);
                    }
                }

                // search cmp
                container.rangeSearchCmp.select([]);

                // filter
                container.filterSearchStore(isLayout);
            };

            this.rangeSearchCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                width: _containerConfig2.default.operatorCmpWidth,
                style: 'margin-bottom: 0',
                emptyText: i18n.select + '..',
                valueField: idProperty,
                displayField: displayProperty,
                editable: false,
                queryMode: 'local',
                hidden: true,
                store: this.rangeSearchStore,
                listConfig: {
                    minWidth: _containerConfig2.default.operatorCmpWidth + (_containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth)
                },
                listeners: {
                    select: function select() {
                        container.onRangeSearchSelect((0, _arrayFrom2.default)(this.getValue())[0]);
                    },
                    expand: function expand() {
                        container.filterSearchStore();
                    }
                }
            });

            this.rangeValueStore = Ext.create('Ext.data.Store', {
                fields: [idProperty, nameProperty],
                listeners: {
                    add: function add() {
                        container.rangeValueCmp.select(this.getRange());
                    },
                    remove: function remove() {
                        container.rangeValueCmp.select(this.getRange());
                    }
                }
            });

            this.rangeValueCmp = Ext.create('Ext.form.field.ComboBox', {
                multiSelect: true,
                style: 'margin-bottom: 0',
                width: _containerConfig2.default.nameCmpWidth - _containerConfig2.default.operatorCmpWidth - _containerConfig2.default.rangeSetWidth,
                valueField: idProperty,
                displayField: nameProperty,
                emptyText: 'No selected items',
                editable: false,
                hideTrigger: true,
                queryMode: 'local',
                hidden: true,
                store: container.rangeValueStore,
                listConfig: {
                    minWidth: _containerConfig2.default.valueCmpWidth,
                    cls: 'ns-optionselector'
                },
                setOptionValues: function setOptionValues(records) {
                    var me = this;

                    container.rangeValueStore.removeAll();
                    container.rangeValueStore.loadData(records);

                    me.setValue(records);
                },
                listeners: {
                    change: function change(cmp, newVal, oldVal) {
                        newVal = (0, _arrayFrom2.default)(newVal);
                        oldVal = (0, _arrayFrom2.default)(oldVal);

                        if (newVal.length < oldVal.length) {
                            var id = (0, _arrayDifference2.default)(oldVal, newVal)[0];
                            container.rangeValueStore.removeAt(container.rangeValueStore.findExact(idProperty, id));
                        }
                    }
                }
            });

            // function
            this.onRangeSetSelect = function (id) {
                if (!id || id === _containerConfig2.default.defaultRangeSetId) {
                    container.operatorCmp.show();
                    container.valueCmp.show();
                    container.rangeSearchCmp.hide();
                    container.rangeValueCmp.hide();
                } else {
                    container.operatorCmp.hide();
                    container.valueCmp.hide();
                    container.rangeSearchCmp.show();
                    container.rangeValueCmp.show();

                    // legend display name
                    var legends = appManager.getLegendSetById(id).legends.slice();

                    legends.forEach(function (legend) {
                        legend.displayName = legend.name + ' (' + legend.startValue + ' - ' + legend.endValue + ')';
                    });

                    container.rangeSearchStore.loadData(legends);
                    container.rangeSearchStore.sort('startValue', 'ASC');
                }
            };

            this.rangeSetCmp = Ext.create('Ext.form.field.ComboBox', {
                cls: 'ns-combo h22',
                style: 'margin-bottom: 0',
                width: _containerConfig2.default.rangeSetWidth,
                height: 22,
                fieldStyle: 'height: 22px',
                queryMode: 'local',
                valueField: idProperty,
                displayField: nameProperty,
                editable: false,
                storage: {},
                pendingValue: null,
                setPendingValue: function setPendingValue() {
                    if (this.pendingValue) {
                        this.setValue(this.pendingValue);
                        container.onRangeSetSelect(this.pendingValue);

                        this.pendingValue = null;
                    }

                    if (!this.getValue()) {
                        this.pendingValue = _containerConfig2.default.defaultRangeSetId;
                        this.setPendingValue();
                    }
                },
                store: Ext.create('Ext.data.Store', {
                    fields: [idProperty, nameProperty]
                }),
                listeners: {
                    added: function added(cb) {
                        cb.store.add({
                            id: _containerConfig2.default.defaultRangeSetId,
                            name: 'No range set'
                        });

                        var legendSetRecords = container.dataElement.legendSets || container.dataElement.storageLegendSets;

                        if ((0, _isArray2.default)(legendSetRecords) && legendSetRecords.length) {

                            // add legendsets to store
                            cb.store.add(legendSetRecords.map(function (record) {
                                return appManager.getLegendSetById(record.id);
                            }).filter(function (legendSet) {
                                return (0, _isObject2.default)(legendSet);
                            }));

                            // select first legendset
                            cb.setValue(legendSetRecords[0].id);
                            container.onRangeSetSelect(legendSetRecords[0].id);
                        }

                        cb.setPendingValue();
                    },
                    select: function select(cb, r) {
                        var id = (0, _arrayFrom2.default)(r)[0].data.id;
                        container.onRangeSetSelect(id);
                    }
                }
            });

            this.items = [{
                xtype: 'container',
                layout: 'hbox',
                width: _containerConfig2.default.nameCmpWidth,
                items: [this.nameCmp, this.addCmp, this.removeCmp]
            }, this.rangeSearchCmp, this.rangeValueCmp, this.operatorCmp, this.valueCmp, this.rangeSetCmp];

            this.self.superclass.initComponent.call(this);
        }
    });
};
//# sourceMappingURL=DataElementIntegerContainer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ux/DataElementIntegerContainer.js
 ** module id = 166
 ** module chunks = 0 1
 **/